import { render, staticRenderFns } from "./BDXValidationReport.vue?vue&type=template&id=69ae2e1c&scoped=true"
import script from "./BDXValidationReport.vue?vue&type=script&lang=js"
export * from "./BDXValidationReport.vue?vue&type=script&lang=js"
import style0 from "./BDXValidationReport.vue?vue&type=style&index=0&id=69ae2e1c&prod&lang=scss&scoped=true"
import style1 from "./BDXValidationReport.vue?vue&type=style&index=1&id=69ae2e1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ae2e1c",
  null
  
)

export default component.exports